module.exports = __webpack_public_path__ + "static/media/login.d72ff961.svg";